import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EFVideo from '@/components/UI/EFVideo';
import { roundFloat } from '@/utils/common';

const videoPath = '/media/power-stream/detail/pc';

const piece = [0.31, 0.5];
const disPiece = 0.19;
const rate = 1 / (1 - disPiece);

export default function SectionF() {
    const { t } = useLang('powerstream.detail.sectionF');
    const descRef = useRef<HTMLDivElement>(null);
    const videoRef = useRef<HTMLVideoElement>(null);
    const { locale } = useRouter();
    const data = [
        { title: t('wifi'), class: 'wifi-box' },
        { title: t('solar'), class: 'solar-box' },
        { title: t('battery'), class: 'battery-box' },
        { title: t('ac'), class: 'ac-box' },
    ];

    useEffect(() => {
        const descDom: any = descRef.current;
        const scaleValue = (document.documentElement.clientHeight - 96) / 825;
        descDom.style.cssText = `transform:scale(${scaleValue})`;
        const video: any = videoRef.current;

        AniContainer.create({
            syncFromTo: [['.f-section .title', { opacity: 0 }, { opacity: 1 }, 1]],
            triggerElement: '.f-section',
            offset: '10%',
            duration: '20%',
            triggerHook: 1,
        });
        AniContainer.create({
            asyncFromTo: [
                ['.f-section .wifi-box', { opacity: 0 }, { opacity: 1 }, 0.3],
                ['.f-section .solar-box', { opacity: 0 }, { opacity: 1 }, 0.3],
                ['.f-section .battery-box', { opacity: 0 }, { opacity: 1 }, 0.3],
                ['.f-section .ac-box', { opacity: 0 }, { opacity: 1 }, 0.3],
                ['.f-section .opacity-box', { opacity: 1, y: 0 }, { opacity: 0, y: -80 }, 0.5],
                ['.f-section .wifi-box', { opacity: 1 }, { opacity: 0 }, 0.3],
                ['.f-section .solar-box', { opacity: 1 }, { opacity: 0 }, 0.3],
                ['.f-section .battery-box', { opacity: 1 }, { opacity: 0 }, 0.3],
                ['.f-section .ac-box', { opacity: 1 }, { opacity: 0 }, 0.3],
            ],
            triggerElement: '.f-section .sticky-box',
            offset: '-20%',
            triggerHook: 0,
            duration: '120%',
            asyncTimeLine: [2.7, 2.7, 2.7, 2.7, 3.2, 3.4, 3.4, 3.4, 3.4],
        });
        AniContainer.create({
            syncFromTo: [['.f-section .plug-title', { opacity: 0, y: 80 }, { opacity: 1, y: 0 }, 1]],
            triggerElement: '.f-section .sticky-box',
            offset: '110%',
            triggerHook: 0,
            duration: '50%',
        });
        AniContainer.create({
            triggerElement: '.f-section .sticky-box',
            offset: 0,
            triggerHook: 0,
            duration: '200%',
            onProcess: (process: number) => {
                if (video) {
                    const duration: number = video?.current?.duration;
                    if (isNaN(duration)) return;
                    if (process > piece[0] && process < piece[1]) return;
                    if (process > piece[1]) {
                        process = process - disPiece;
                    }
                    process = process * rate;

                    if (process >= 1) {
                        process = 0.998;
                    }

                    const currentTime = roundFloat(duration * process, 2) || 0;
                    video?.setCurrentTime(currentTime);
                }
            },
        });
    }, []);

    return (
        <div className={styles.sectionF}>
            <div className="f-section">
                <div className="text-box">
                    <div className="opacity-box">
                        <p className="title">{t.rich('title', { HighLight: (text) => <span className="green-text">{text}</span> })}</p>
                        <p className="sub-title">{t('subTitle')}</p>
                    </div>
                </div>
                <div className="sticky-box">
                    <div className="machine-box">
                        <div className="plug-box">
                            <p className="plug-title">{t('breeze')}</p>
                        </div>
                        <EFVideo
                            ref={videoRef}
                            sources={
                                ['eu', 'de', 'fr', 'it', 'es'].includes(String(locale))
                                    ? [`${videoPath}/sectionF_eu.mp4`, `${videoPath}/sectionF_eu.mp4`]
                                    : [`${videoPath}/sectionF.webm`, `${videoPath}/sectionF.mp4`]
                            }
                            className="machine-video"
                            autoPlay={false}
                            muted
                        />
                        <div className="machine-desc" ref={descRef}>
                            {data.map((item: Record<string, string>, index) => (
                                <div key={index} className={`common-desc ${item.class}`}>
                                    <p className="line"></p>
                                    <p className="title">{item.title}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
